<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { type RoutePointAlertsType } from './AssignmentApi';
    import { VehicleLimitItem } from './VehicleLimit/VehicleLimitItem';
    import TemplateIcon from '../../shared/Icons/TemplateIcon.svelte';

    export let alerts: RoutePointAlertsType;
    export let title: string = '';
    export let load: boolean = false;
    export let values: boolean = false;
    export let units: boolean = false;
    export let percent: boolean = false;
    export let scale: number = 0.5;

    let loadPercent: number = 0;
    let nonNormativeJobs: number = 0;

    let types: any = {
        parcels: {src: VehicleLimitItem._ALERT_ICON_PARCELS, title: $_('Vehicle_parcel_limit'), unit: ''},
        total_weight: {src: VehicleLimitItem._ALERT_ICON_TOTAL_WEIGHT, title: $_('Vehicle_total_weight'), unit: 'kg'}
    };
    for (let t in types) {
        types[t].color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_UNSET;
        let alert = alerts[t as keyof typeof alerts];
        if (alert?.limit && typeof(alert?.value) == 'number') {
            if (alert.value > alert.limit) {
                types[t].color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_ERROR;
            } else if (alert.value / alert.limit > 0.9) {
                types[t].color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_WARNING;
            } else {
                types[t].color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_SUCCESS;
            }
            loadPercent = Math.max(loadPercent, alert.value / alert.limit);
        }
        types[t].src = 'data:image/svg+xml;base64,' + btoa(types[t].src.replace(/\{color\}/g, types[t].color));
        //types[t].title = $_(types[t].title, {values: {count: alert}});
    };

    nonNormativeJobs = alerts.non_normative_size?.value || 0;

    loadPercent = Math.round(100 * loadPercent);
</script>

<div class="container">
    {#if title}
        <div class="title">{title}
            {#if load}
                <span class="load">{loadPercent}%</span>
            {/if}
        </div>
    {/if}
    {#each Object.entries(alerts) as [type, alert]}
        {#if alert && types[type] && types[type].color != VehicleLimitItem._VEHICLE_LIMIT_COLOR_UNSET}
            <div class="alert">
                <TemplateIcon src={types[type].src} {scale} alt={types[type].title} hover={types[type].title} />
                {#if values}
                    <span class="values" title={types[type].title}>
                        <span class="value">{typeof alert.value==='number' ? Math.round(alert.value) : '---'}</span>/<span class="limit">{typeof alert.limit==='number' ? Math.round(alert.limit) : '---'}</span>
                    {#if units}
                        <span class="unit" title={types[type].title}>{types[type].unit}</span>
                    {/if}
                    </span>
                {/if}
                {#if percent && alert.limit}
                    <span class="percent" title={types[type].title}>
                        {#if values}({/if}{Math.round(100*(alert.value || 0)/alert.limit)}%{#if values}){/if}
                    </span>
                {/if}
            </div>
        {/if}
    {/each}
    {#if nonNormativeJobs > 0}
        <div class="alert" style="color: {VehicleLimitItem._VEHICLE_LIMIT_COLOR_WARNING}">{$_('Vehicle_limit_non_normative_jobs')}</div>
    {/if}
</div>

<style>
    .container {
        font-size: 12px;
    }
    .title {
        font-size: 14px;
        white-space: nowrap;
        padding-bottom: 2px;
        margin-bottom: 5px;
        border-bottom: 1px solid #999;
    }
    .load {
        font-weight: bold;
    }
    .alert {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 3px;
        margin: 5px 0;
    }
    .values {
        font-size: 12px;
    }
    .value {
        display: inline-block;
        padding-right: 2px;
    }
    .limit {
        display: inline-block;
        padding-left: 2px;
    }
    .unit {
        opacity: 0.6;
    }
</style>
